import { render } from "./btnGuardar.vue?vue&type=template&id=0167a38b"
import script from "./btnGuardar.vue?vue&type=script&lang=js"
export * from "./btnGuardar.vue?vue&type=script&lang=js"

import "./btnGuardar.vue?vue&type=style&index=0&id=0167a38b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__